import { Shield, Wrench, MessageSquare, FileCheck } from "lucide-react"
import { useLanguage } from "@/contexts/LanguageContext"

const GuaranteesSection = () => {
  const { t } = useLanguage()
  const items = [
    { icon: Shield, title: t('guarantees.quality'), desc: t('guarantees.quality.desc') },
    { icon: Wrench, title: t('guarantees.custom'), desc: t('guarantees.custom.desc') },
    { icon: MessageSquare, title: t('guarantees.professionalism'), desc: t('guarantees.professionalism.desc') },
    { icon: FileCheck, title: t('guarantees.ip'), desc: t('guarantees.ip.desc') },
  ]
  return (
    <section className="py-24 md:py-32 bg-je-ivory">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <span className="eyebrow mb-5">05 — Engagements</span>
            <h2 className="text-section-title font-serif font-medium text-je-black mt-4 text-balance">{t('guarantees.title')}</h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-lg text-je-gray-dark text-pretty">{t('guarantees.subtitle')}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-je-navy/15 border border-je-navy/15">
          {items.map((it, i) => (
            <div key={i} className="bg-je-white p-8 lg:p-10">
              <it.icon className="w-6 h-6 text-je-red mb-8" strokeWidth={1.5} />
              <h3 className="font-serif text-2xl font-medium text-je-black mb-3 leading-tight">{it.title}</h3>
              <p className="text-sm text-je-gray-dark leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
export default GuaranteesSection
